'use client';

import { Container, Grid, Stack, Typography } from '@mui/material';
import cx from 'clsx';
import { useTranslations } from 'next-intl';

import { aiServiceGroups } from '@/config/ai-services.config';
import colors from '@/styles/themes/colors';
import useScrollReveal from '@/utils/hooks/useScrollReveal';

import AIServiceCard from './AIServiceCard';
import styles from './AIServicesSection.module.scss';

const AIServicesSection = () => {
  const t = useTranslations('home.aiServicesSection');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const groups = t.raw('groups' as any) as Record<string, { title: string; items: string[] }>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const links = t.raw('links' as any) as Record<string, string>;
  const { setRef, isVisible } = useScrollReveal<HTMLDivElement>(aiServiceGroups.length);

  return (
    <Container component="section" maxWidth="xl" className={styles.container}>
      <Grid container spacing={{ xs: 6, md: 12, xl: 20 }}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Stack className={styles.introColumn}>
            <Typography variant="h2">{t('title')}</Typography>
            <Typography variant="body1" style={{ color: colors.graytone300 }}>
              {t('description')}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Grid container spacing={{ xs: 8, md: 6 }}>
            {aiServiceGroups.map((group, index) => (
              <Grid key={group.id} size={{ xs: 12, sm: 6 }}>
                <Stack ref={setRef(index)} className={cx(styles.cardWrapper, { [styles.visible]: isVisible(index) })}>
                  <AIServiceCard
                    group={group}
                    title={groups[group.id].title}
                    items={groups[group.id].items}
                    readMoreText={links[group.id]}
                    href={`/services/${group.slug}`}
                  />
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AIServicesSection;
